// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"8608111e","198":"9fa7f546","495":"d4a7125e","616":"1a7bc026","715":"162b9ae4","935":"e868bdce"}[chunkId] + ".chunk.js";
};